import { render } from "./CompanyTab.vue?vue&type=template&id=297faa56&scoped=true"
import script from "./CompanyTab.vue?vue&type=script&lang=js"
export * from "./CompanyTab.vue?vue&type=script&lang=js"

import "./CompanyTab.vue?vue&type=style&index=0&id=297faa56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297faa56"]])

export default __exports__